import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { useGetCategoryQuery } from '../../../../api/services/categoriesApi'
import { useUpdateCategoryAccessPolicyMutation } from '../../../../api/services/categoryAccessPolicyApi'
import FunctionCheckbox from '../../../other/FunctionCheckbox'
import NewModal from '../../../root/modals/NewModal'

const UpdateCategoryAccessPolicyModal = ({ open, onClose, policy }) => {
  const [policyName, setPolicyName] = useState('')
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([])
  const { t } = useTranslation()
  const [updatePolicy] = useUpdateCategoryAccessPolicyMutation()

  const company = useSelector((state) => state.company.company)
  const { data: categories } = useGetCategoryQuery(company?.id)

  useEffect(() => {
    if (policy) {
      setPolicyName(policy.name || '')
      setSelectedCategoryIds(policy.categoryIds || [])
    }
  }, [policy])

  const handleCategoryToggle = (categoryId) => {
    setSelectedCategoryIds((prev) =>
      prev.includes(categoryId) ? prev.filter((id) => id !== categoryId) : [...prev, categoryId],
    )
  }

  const handleSubmit = async () => {
    if (!policyName.trim() || !selectedCategoryIds.length) {
      return toast.error(t('input_all_fields'))
    }

    try {
      const response = await updatePolicy({
        policyId: policy.id,
        policy: { name: policyName, categoryIds: selectedCategoryIds },
      }).unwrap()
      toast.success(response.message)
      onClose()
    } catch (error) {
      toast.error(error.data?.message || t('err_occ'))
    }
  }

  return (
    <NewModal
      showModal={open}
      closeModal={onClose}
      setShowModal={onClose}
      btns
      titleClose={t('close')}
      titleSubmit={t('submit')}
      title={t('edit_policy')}
      onClickClose={onClose}
      onClickSubmit={handleSubmit}
    >
      <form className="justify-center">
        <div className="w-full">
          <input
            type="text"
            name="name"
            value={policyName}
            placeholder={t('policy_name')}
            className="w-full h-[48px] rounded-lg border-[1px] border-[#E6E6E5] py-[9px] px-[8px] placeholder:text-[#073C59] font-popins font-normal text-sm leading-5"
            onChange={(e) => setPolicyName(e.target.value)}
          />

          <label className="font-popins font-semibold w-full flex my-4 text-base leading-6 text-[#073C59]">
            {t('allowed_categories')}
          </label>
          <div className="w-full grid grid-cols-2 gap-2">
            {categories?.map((category) => (
              <button
                className="text-left"
                key={category.id}
                type="button"
                onClick={() => handleCategoryToggle(category.id)}
              >
                <FunctionCheckbox
                  label={category.categoryName}
                  checked={selectedCategoryIds.includes(category.id)}
                />
              </button>
            ))}
          </div>
        </div>
      </form>
    </NewModal>
  )
}

export default UpdateCategoryAccessPolicyModal
